import React from 'react';
import {
    Box,
    Divider,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
} from '@mui/material';
import {PopoverOrigin} from '@mui/material/Popover';

export interface OptionsMenuOption {
    icon: React.ReactNode;
    title: string;
    subtitle?: string;
    onClick: () => void;
}

interface Props {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    options: OptionsMenuOption[];
    /** Content above the entries, e.g. the file format switch of the list export. */
    header?: React.ReactNode;
    anchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
}

// Dropdown menu with icon + title + grey subtitle entries, e.g. used for the
// Save options in the create node form and the list export (format + columns)
const OptionsMenu = ({
    anchorEl,
    open,
    onClose,
    options,
    header,
    anchorOrigin = {vertical: 'bottom', horizontal: 'right'},
    transformOrigin = {vertical: 'top', horizontal: 'right'},
}: Props) => {

    const handleOptionClick = (option: OptionsMenuOption) => {
        onClose();
        option.onClick();
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
        >
            {header && (
                // Not a menu item: clicks inside must not close the menu
                <Box sx={{ px: 2, pt: 0.5, pb: 1 }}>{header}</Box>
            )}
            {header && <Divider />}
            {options.map((option) => (
                <MenuItem key={option.title} onClick={() => handleOptionClick(option)}>
                    <ListItemIcon>{option.icon}</ListItemIcon>
                    <ListItemText primary={option.title} secondary={option.subtitle}/>
                </MenuItem>
            ))}
        </Menu>
    );
};

export default OptionsMenu;
